import React from "react";
import { Select, ConfigProvider } from "antd";
// import "./Dropdown.scss";

/**
 * Dropdown Component
 */
const Dropdown = ({
  options = [],
  defaultValue = null,
  placeholder = "Select an option",
  disabled = false,
  loading = false,
  // variant = "filled",
  size = "large",
  style = {},
  className = "",

  onChange,
  ...rest
}) => {
  const handleChange = (value) => {
    if (onChange) onChange(value);
  };

  return (
    <ConfigProvider
      theme={{
        components: {
          Select: {},
        },
      }}
    >
      <Select
        size={size}
        showSearch
        // variant="filled"
        defaultValue={defaultValue}
        placeholder={placeholder}
        disabled={disabled || loading}
        filterOption={(input, option) =>
          (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
        }
        style={{
          width: "100%",
          height:"39.6px",
          ...style,
        }}
        options={options}
        onChange={handleChange}
        className={`-dropdown ${className}`}
        {...rest}
      />
    </ConfigProvider>
  );
};

export default Dropdown;
